<template>
  <div class="footer">
    <div class="box">
      <div class="top">
        <div class="text">
          <div><a href="mailto:marketing@today365.com.cn">联系我们 ruiaoshi@today365.com.cn</a></div>
          <div>© Copyright 版权所有：北京瑞奥视科技有限公司</div>
        </div>
        <div class="erweima">
          <img src="/img/newPages/weibo.png" alt="" />
          <span>关注微博</span>
        </div>
        <div class="erweima erweima2">
          <img src="/img/newPages/weixin-1.jpg" alt="" />
          <span>关注微信</span>
        </div>
      </div>
    </div>
    <div style="background-color: #273143; width: 100%; margin-top: 49px">
      <div class="box">
        <div class="bottom">
          <span>
            <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010702002525" target="_blank" rel="noopener">京公网安备 11010702002525号</a>
          </span>
          <span><a href="https://beian.miit.gov.cn/">京ICP备06066266号-1</a></span>
          <span><a href="/img/network-culture.jpg" target="_blank" rel="noopener">京网文【2024】2601-127号</a></span>
          <span><a href="/img/audio-visual.png" target="_blank" rel="noopener">信息网络传播视听节目许可证0110583</a></span>
          <span><a href="/img/value-added.png" target="_blank" rel="noopener">增值电信业务经营许可证</a></span>
          <span><a href="/img/make.png" target="_blank" rel="noopener">广播电视节目制作经营许可证</a></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainFooter'
}
</script>

<style lang="scss" scoped>

.footer {
  width: 100%;
  background: #414d63;
}

.box {
  width: $content-width;
  margin: auto;
  box-sizing: border-box;
  overflow: hidden;
}

.top {
  display: flex;
  margin-top: 41px;

  .text {
    height: 49px;
    justify-content: space-between;
    margin-top: 15px;
    margin-left: 42px;
    margin-right: auto;
    font-family: PingFang;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    display: flex;
    flex-direction: column;

    a {
      text-decoration: none;
      color: #fff;
    }
  }

  .erweima {
    width: 92px;
    font-family: PingFang;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 92px;
      height: 92px;
    }

    span {
      margin-top: 8px;
    }
  }

  .erweima2 {
    margin-left: 16px;
    margin-right: 120px;
  }
}

.bottom {
  height: 72px;
  font-family: PingFang;
  font-weight: 400;
  font-size: 12px;
  color: #b1b1b1;
  padding-left: 76px;
  padding-right: 76px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    text-decoration: none;
    color: #b1b1b1;
  }
}
</style>
